var window=global;var $CLJS=require("./cljs_env");require("./goog.base.js");require("./goog.html.safehtml.js");
$CLJS.Ha=String.prototype.repeat?function(a,b){return a.repeat(b)}:function(a,b){return Array(b+1).join(a)};